import * as ScrollMagic from 'scrollmagic'

/**
 * @module AnchorLinksNavigation
 * To debugging the scrolling and elements position,
 * uncomment the funciton ".addIndicators()" in the code base to show the Indicators in frontend
 * for more infomation please visit
 * http://scrollmagic.io/examples/basic/scene_manipulation.htmlhttps://greensock.com/docs
 */
(function AnchorLinksNavigation() {
    function AnchorLinksNavigation($dom) {
        /**
         * // local object availability
         * @type {AnchorLinksNavigation}
         * @private
         */
        var _this = this

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            this.triggerHookNum = 0 // 'onLeave','onCenter','onEnter', OR the number from  0.00 to 1.00
            this.headerHeight = $("[data-html-element='header']")[0].clientHeight
            this.anchorLinksNavigationHeight = $dom[0].clientHeight
            this.offset = '-' + _this.headerHeight + 'px'
            this.scrollOffset = 16
            this.$navigationLinkItemElements = $dom.find('.js-link-item')

            _this.stickyOnScrollWhenMeetHeader()
            _this.anchorLinkSmoothScroll()

            // scroll to id if user called page with hash
            if (window.location.href.indexOf('#') > -1) {
                var isolatedCurrentHash = window.location.href.substr(window.location.href.indexOf('#'))

                // wait some time until default user scroll to id is done
                setTimeout(function () {
                    _this.scrollToHash(decodeURI(isolatedCurrentHash))
                }, 100)
            }
        }

        /**
         * @method stickyOnScroll
         * @returns {undefined}
         */
        this.stickyOnScrollWhenMeetHeader = function () {
            var pin = new ScrollMagic.Scene({
                // using option 'duration:99999 ', to force Sticky Pin Element sticks at the curtain position for as long as the user is not scrolling downwards more then 99999px started from sticky point
                duration: 99999,
                triggerElement: $dom[0],
                triggerHook: _this.triggerHookNum,
                offset: _this.offset,
            })
                .setPin($dom[0], {pushFollowers: false})
                /** to debugging the scrolling and element position, uncomment the line below to show the Indicators in frontend */
                /**
                 be aware of when uncommenting the method .addIndicators(). ScrollMagic.js will insert an empty div element with inline style "height:99999px" directly above the closing body tag </body> due to the usage of
                 combination of 'duration: 99999' option in  Scene() method and {pushFollowers: false} option in setPin() method.
                 please don't be fooled by the extra div element caused by .addIndicators() method.
                 */
                // .addIndicators()
                .addTo(new ScrollMagic.Controller())
        }

        /**
         * @method anchorLinkSmoothScroll
         * @returns {undefined}
         */
        this.anchorLinkSmoothScroll = function () {
            $(document).on('click', 'a[href^="#"]', function (event) {
                event.preventDefault()
                var href = $(this).attr('href')
                window.location.hash = _this.scrollToHash(href)
            })
        }

        /**
         * Scroll to give hash
         * @param hash
         * @returns {string} Hash as id(without #)
         */
        this.scrollToHash = function (hash) {
            var firstNavigationLinkItem = _this.$navigationLinkItemElements[0]

            if ($(hash).length === 0) {
                throw new Error('Given hash was not found: ' + hash)
            }

            // Without scrollOffset when first item is active
            if (hash === $(firstNavigationLinkItem).attr('href')) {
                $('html, body').animate(
                    {
                        scrollTop: $(hash).offset().top - _this.headerHeight - _this.anchorLinksNavigationHeight,
                    },
                    300
                )
                // With scrollOffset
            } else {
                $('html, body').animate(
                    {
                        scrollTop:
                            $(hash).offset().top -
                            _this.headerHeight -
                            _this.anchorLinksNavigationHeight -
                            _this.scrollOffset,
                    },
                    300
                )
            }

            _this.$navigationLinkItemElements.removeClass('active')
            // set active state in navigation
            $dom.find("a[href='" + hash + "']").addClass('active')
            var cleanHash = hash.substr(hash.indexOf('#') + 1)
            return cleanHash
        }

        /**
         * initialize call
         */
        _this.init()
    }

    // define the global scope
    if (!window.Creaton) {
        window.Creaton = {}
    }

    window.Creaton.AnchorLinksNavigation = AnchorLinksNavigation
})()

$(document).ready(function () {
    var $productAnchorLinksNavigationElement = $('.js-product-anchor-links-navigation')
    if ($productAnchorLinksNavigationElement.length >= 1) {
        new window.Creaton.AnchorLinksNavigation($productAnchorLinksNavigationElement)
    }
})
